import { render, staticRenderFns } from "./sloth.vue?vue&type=template&id=7e6a4cdb&scoped=true&"
import script from "./sloth.vue?vue&type=script&lang=js&"
export * from "./sloth.vue?vue&type=script&lang=js&"
import style0 from "./sloth.vue?vue&type=style&index=0&id=7e6a4cdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6a4cdb",
  null
  
)

export default component.exports